// extracted by mini-css-extract-plugin
export var orderSummary = "_s3-0";
export var showMoreLessButton = "_s3-1";